// 画面の更新ごとに呼ぶタイマー（段階 C の2 の 7g、2026-10-26。前は d3 v4.10.2 の d3-timer。d3-timer, Copyright 2010-2017 Mike Bostock, BSD-3-Clause の決まりに合わせた）。
// 同じ処理の中で作った動きは同じ時刻から数える（now は次の画面の更新まで同じ値）。更新の途中で足したタイマーも、その時刻を過ぎていれば同じ更新で呼ぶ
// （動きの始まり → 最初の一コマを同じ更新で描く、の順番のため）。動き（transition.ts）と jQuery の代わりの動き（fx.ts）が使う

type TimerCallback = (elapsed: number) => void;

export class Timer {
  _call: TimerCallback | null = null;
  _time = 0;
  /** 呼ぶ（delay は time から数えて何ミリ秒後から呼ぶか） */
  restart(callback: TimerCallback, delay = 0, time: number = now()): void {
    this._call = callback;
    this._time = time + delay;
    if (timers.indexOf(this) < 0) timers.push(this);
    wake();
  }
  stop(): void {
    this._call = null;
  }
}

const timers: Timer[] = [];
let clockNow = 0;
let frame = 0;

/** 今の時刻（ms。画面の更新の中ではその更新の時刻、外では次の更新まで同じ値） */
export function now(): number {
  if (!clockNow) {
    clockNow = performance.now();
    requestAnimationFrame(() => {
      if (!flushing) clockNow = 0;
    });
  }
  return clockNow;
}

let flushing = false;
function wake(): void {
  if (!frame) frame = requestAnimationFrame(flush);
}
function flush(): void {
  frame = 0;
  flushing = true;
  clockNow = performance.now();
  try {
    // 呼んでいる間に足されたタイマーも、時刻を過ぎていれば同じ更新で呼ぶ（d3-timer と同じ）
    for (let i = 0; i < timers.length; i++) {
      const t = timers[i];
      if (!t._call) continue;
      const e = clockNow - t._time;
      if (e >= 0) t._call(e);
    }
  } finally {
    for (let i = timers.length - 1; i >= 0; i--) if (!timers[i]._call) timers.splice(i, 1);
    flushing = false;
    clockNow = 0;
    if (timers.length) wake();
  }
}

/** タイマーを作って呼ぶ（d3.timer） */
export function timer(callback: TimerCallback, delay?: number, time?: number): Timer {
  const t = new Timer();
  t.restart(callback, delay, time);
  return t;
}

/** 一度だけ呼ぶ（d3.timeout。elapsed は delay を過ぎてからの時間） */
export function timeout(callback: TimerCallback, delay = 0, time?: number): Timer {
  const t = new Timer();
  t.restart(
    (elapsed) => {
      t.stop();
      callback(elapsed + delay);
    },
    delay,
    time,
  );
  return t;
}
